import script from "./ViewPVMemosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPVMemosPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewPVMemosPage.vue?vue&type=style&index=0&id=16fc677c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fc677c"]])

export default __exports__